export function parallax() {
    let $window = $(window);
    let $parallax = $(".parallax");
    let zoomScale = 0;
    let coef;
    $window.on("load scroll", function () {
        let winTop = $window.scrollTop();
        $parallax.each(function (i, it) {
            let itemTop = $(it).offset().top;
            let speed = $(it).data("scroll-speed");
            if (winTop + $window.innerHeight() / 1.3 > itemTop && winTop + $window.innerHeight() / 1.3 < itemTop + $window.innerHeight() + $window.innerHeight() / 1.3) {
                if ($(it).hasClass("parallax-zoom")) {
                    zoomScale = Math.trunc(((winTop + $window.innerHeight() / 2) - itemTop) / speed);
                    if (zoomScale > 9) {
                        coef = '';
                    } else {
                        coef = "0"
                    }
                    $(it).find(".photo").css("transform", "translate(-50%,-50%) scale(1.0" + coef + zoomScale + ")");
                }
                if ($(it).hasClass("move-top")) {
                    $(it).find(".photo, .parallax-element").css('margin-top', Math.round((winTop - itemTop) / speed));
                }
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/parallax.js